import React from 'react';
import { Star, Quote } from 'lucide-react';
import { testimonials } from '../mock';

const Testimonials = () => {
  return (
    <section className="relative py-24 lg:py-32 bg-[#080808]">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="text-center mb-16 max-w-2xl mx-auto">
          <div className="inline-block px-4 py-1.5 rounded-full border border-[#D4A94F]/30 bg-[#D4A94F]/5 mb-5">
            <span className="text-xs font-medium tracking-widest uppercase text-[#E9C46A]">
              Testimoni
            </span>
          </div>
          <h2 className="text-white font-bold text-4xl md:text-5xl leading-tight tracking-tight mb-5">
            Kata <span className="gold-gradient-text">Musisi Kami</span>
          </h2>
        </div>

        <div className="grid md:grid-cols-3 gap-6">
          {testimonials.map((t, i) => (
            <div
              key={t.name}
              className="relative bg-[#0f0f0f] border border-white/[0.06] hover:border-[#D4A94F]/40 rounded-3xl p-8 card-transition hover:-translate-y-1"
            >
              <Quote className="absolute top-6 right-6 w-8 h-8 text-[#D4A94F]/20" />
              <div className="flex gap-1 mb-5">
                {Array.from({ length: t.rating }).map((_, idx) => (
                  <Star key={idx} className="w-4 h-4 fill-[#E9C46A] text-[#E9C46A]" />
                ))}
              </div>
              <p className="text-neutral-300 leading-relaxed mb-6">“{t.quote}”</p>
              <div className="flex items-center gap-3 pt-5 border-t border-white/[0.06]">
                <div className="w-11 h-11 rounded-full bg-gradient-to-br from-[#E9C46A] to-[#B8892C] flex items-center justify-center text-black font-bold">
                  {t.name.charAt(0)}
                </div>
                <div>
                  <p className="text-white font-semibold text-sm">{t.name}</p>
                  <p className="text-neutral-500 text-xs">{t.role}</p>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Testimonials;
